import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { VersionsReducerHandlers, GeneralReducerHandlers } from './handlers';
import { VersionsActionTypes, GeneralActionTypes } from '../actions/types';

const versionsReducer = createReducer(
  {
    ...initialState,
    shouldCreateVersion: false,
  },
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore({ ...initialState, shouldCreateVersion: false }),
    ...VersionsReducerHandlers.getDataToCompareVersions,
    ...VersionsReducerHandlers.addVersion,
    [VersionsActionTypes.setShouldCreateVersion]: VersionsReducerHandlers.setShouldCreateVersion,
    ...VersionsReducerHandlers.restoreVersion,
  },
);

export default versionsReducer;
